import { AxiosResponse } from 'axios';
import { objectKeysToCamelCase } from 'utils/common';
import axiosWithToken from './axios-with-token';

interface ContainerTypeRemote {
  key: string;
  name: string;
  order: number;
}

export interface ContainerType {
  key: string;
  name: string;
  order: number;
}

export const enum ContainerTypeQueryKeys {
  ContainerTypes = 'containerTypes',
}

export async function fetchContainerTypes({
  signal = undefined,
}: {
  signal: AbortSignal | undefined;
}) {
  const response: AxiosResponse<ContainerTypeRemote[]> = await axiosWithToken.get(
    '/core/api/v1/erl/container_type',
    {
      signal,
    }
  );
  const containerTypes: ContainerType[] = objectKeysToCamelCase(response.data);
  return containerTypes;
}
